import { useContext } from "react";
import _ from "lodash";

import Slider from "src/components/slider";
import Button from "src/components/button";

import { DealRoomActionPlanContext } from "../context";

import styles from "./styles.module.scss";

const DeleteActionSlider = ({ show, handleClose, handleFinish }) => {
  const { state } = useContext(DealRoomActionPlanContext);

  const deleteActionSliderObj = _.get(state, "deleteActionSlider");

  const deleteAction = _.get(deleteActionSliderObj, "action");
  const stageId = _.get(deleteActionSliderObj, "stageId");

  const targetAction = _.get(state, "deleteAction");
  const loading = _.get(targetAction, "loading", false);

  const handleClickConfirm = () => {
    let newActionsOrder: string[] = [];

    const allActions = _.get(state, `actions[${stageId}].items`, []);
    const actionsAfterDeletion = _.filter(allActions, action => _.get(action, "id", "") !== _.get(deleteAction, "id"));

    newActionsOrder = _.map(actionsAfterDeletion, action => _.get(action, "id"));

    handleFinish(newActionsOrder, stageId, _.get(deleteAction, "id", ""));
  }

  const recipients = _.get(deleteAction, "recipients", []);
  const assets = _.get(deleteAction, "assets", []);

  return (
    <Slider.Dialog width="400" show={show} onClose={handleClose}>
      <Slider.Header>
        <div className={styles.headerContainer}>
          <p className={styles.header}>deleting</p>
          <p className={styles.subtext}>
            <span className={styles.highlight}>
              {_.get(deleteAction, "actionItem", "N/A")}
            </span>{" "}
            action item containing
          </p>
        </div>
      </Slider.Header>

      <Slider.Body>
        <div className={styles.bodyContainer}>
          <div className={styles.detailContainer}>
            <p className={styles.detailCount}>{`${_.size(recipients)} Stakeholder${_.size(recipients) > 1 ? "s" : ""}`}</p>
            <p className={styles.detailCount}>{`${_.size(assets)} Attachment${_.size(assets) > 1 ? "s" : ""}`}</p>
          </div>
          <p className={styles.footerNote}>
            Do you wish to delete this action item?
          </p>
        </div>
      </Slider.Body>

      <Slider.Actions>
        <Button
          icon="paperflite-tick"
          text={loading ? "Confirming" : "Confirm"}
          variant="primary"
          onClick={handleClickConfirm}
          disabled={loading}
        />
        <Button text="Cancel" variant="secondary" onClick={handleClose} />
      </Slider.Actions>
    </Slider.Dialog>
  );
};

export default DeleteActionSlider;
